var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "div" },
    [
      _c(
        "el-tabs",
        {
          staticStyle: { height: "100%" },
          attrs: { type: "card" },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "电价格表", name: "电" } },
            [_c("ElectricityPrice", { ref: "ElectricityPrice" })],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "水价格表", name: "水" } },
            [_c("WaterPrice", { ref: "WaterPrice" })],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "气价格表", name: "气" } },
            [_c("GasPrice", { ref: "GasPrice" })],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "油价格表", name: "油" } },
            [_c("OilPrice", { ref: "GasPrice" })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }